import { post, get, del, baseURL, TOKEN_KEY } from './apiClient';
import { urls } from './urlService';

const AUTH_KEY = 'user_session';

export const isLoggedIn = () => {
  return !!localStorage.getItem(TOKEN_KEY);
};

export const getCurrentUser = () => {
  const data = localStorage.getItem(AUTH_KEY);
  return data ? JSON.parse(data) : null;
};

export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

export const login = async (email, password) => {
  try {
    const data = await post(urls.authLogin, { email, password });
    localStorage.setItem(TOKEN_KEY, data.token);
    const userSession = { ...data.user, username: data.user.name };
    localStorage.setItem(AUTH_KEY, JSON.stringify(userSession));
    return { success: true, user: userSession };
  } catch (err) {
    return { success: false, message: err.message || 'Invalid credentials' };
  }
};

export const register = async (fullName, phone, email, password) => {
  try {
    const data = await post(urls.authRegister, { name: fullName, phone, email, password });
    localStorage.setItem(TOKEN_KEY, data.token);
    const userSession = { ...data.user, username: data.user.name, phone };
    localStorage.setItem(AUTH_KEY, JSON.stringify(userSession));
    return { success: true, user: userSession };
  } catch (err) {
    if (err.message.includes('409') || err.message.includes('already registered')) {
      return { success: false, message: 'Email already registered' };
    }
    return { success: false, message: err.message || 'Registration failed' };
  }
};

export const loginWithGoogle = async (googleUser) => {
  try {
    const autoPassword = 'google-' + googleUser.sub + '-oauth';
    const exists = await post(urls.authLogin, { email: googleUser.email, password: autoPassword })
      .catch(() => null);
    if (exists) {
      localStorage.setItem(TOKEN_KEY, exists.token);
      const userSession = { ...exists.user, username: exists.user.name, picture: googleUser.picture };
      localStorage.setItem(AUTH_KEY, JSON.stringify(userSession));
      return { success: true, user: userSession };
    }
    const data = await post(urls.authRegister, {
      name: googleUser.name, email: googleUser.email, phone: '', password: autoPassword,
    });
    localStorage.setItem(TOKEN_KEY, data.token);
    const userSession = { ...data.user, username: data.user.name, picture: googleUser.picture };
    localStorage.setItem(AUTH_KEY, JSON.stringify(userSession));
    return { success: true, user: userSession };
  } catch (err) {
    return { success: false, message: err.message || 'Google login failed' };
  }
};

export const logout = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(AUTH_KEY);
  window.location.reload();
};

// Address Management
function mapApiAddress(addr) {
  return {
    id: addr.id,
    name: addr.name,
    phone: addr.phone,
    fullAddress: addr.addressLine1 + (addr.addressLine2 ? ', ' + addr.addressLine2 : ''),
    pincode: addr.pincode,
    nearby: '',
  };
}

function mapFormAddress(form) {
  return {
    name: form.name,
    phone: form.phone,
    addressLine1: form.fullAddress || form.addressLine1 || '',
    addressLine2: form.nearby || form.addressLine2 || '',
    city: form.city || '',
    state: form.state || '',
    pincode: form.pincode,
  };
}

export const getAddresses = async () => {
  if (!isLoggedIn()) return [];
  try {
    const data = await get(urls.addresses);
    return data.map(mapApiAddress);
  } catch {
    return [];
  }
};

export const addAddress = async (address) => {
  try {
    const data = await post(urls.addresses, mapFormAddress(address));
    return mapApiAddress(data);
  } catch (err) {
    console.error('Add address failed:', err);
    return null;
  }
};

export const removeAddress = async (id) => {
  try {
    await del(urls.addressById(id));
  } catch (err) {
    console.error('Remove address failed:', err);
  }
};